/* eslint-disable no-nested-ternary */
import { WhatsAppOutlined } from '@ant-design/icons';

function SalesFuturePlan() {
  const salesFeatures = [
    {
      name: 'CustomerLoyalty.jsx',
      description: 'Implement points system and reward redemption',
      benefit: 'Increase repeat customers and sales',
      priority: 'High',
    },
    {
      name: 'SalesCommission.jsx',
      description: 'Track and calculate staff commissions automatically',
      benefit: 'Motivate sales team with transparent incentives',
      priority: 'Medium',
    },
    {
      name: 'DiscountManager.jsx',
      description: 'Create and manage promotional campaigns',
      benefit: 'Boost sales during slow periods',
      priority: 'High',
    },
    {
      name: 'SalesForecast.jsx',
      description: 'Predict future sales based on historical data',
      benefit: 'Better inventory planning and staffing',
      priority: 'Medium',
    },
    {
      name: 'MobileSales.jsx',
      description: 'Tablet/phone optimized sales interface',
      benefit: 'Enable floor staff to process sales anywhere',
      priority: 'Low',
    },
  ];

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-blue-600">Sales Module Roadmap</h1>

      <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-gray-700">
        <p className="text-lg text-gray-300 mb-6">
          Planned enhancements for your sales system. Help us prioritize
          based on your business needs.
        </p>

        <div className="grid gap-4 md:grid-cols-2">
          {salesFeatures.map((feature) => (
            <div
              key={feature.name}
              className={`p-4 rounded-lg border-l-4 ${
                feature.priority === 'High' ? 'border-red-500'
                  : feature.priority === 'Medium' ? 'border-amber-500' : 'border-gray-500'
              } bg-gray-800/50`}
            >
              <div className="flex justify-between items-start">
                <h3 className="text-xl font-semibold text-amber-400">{feature.name}</h3>
                <span className={`px-2 py-1 text-xs rounded-full ${
                  feature.priority === 'High' ? 'bg-red-900/50 text-red-300'
                    : feature.priority === 'Medium' ? 'bg-amber-900/50 text-amber-300'
                      : 'bg-gray-700 text-gray-400'
                }`}
                >
                  {feature.priority}
                  {' '}
                  Priority
                </span>
              </div>
              <p className="text-gray-300 mt-2">{feature.description}</p>
              <p className="text-green-400 mt-2 text-sm">
                <span className="font-medium">Business Impact:</span>
                {' '}
                {feature.benefit}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 p-4 bg-blue-900/20 rounded-lg">
          <h3 className="text-lg font-semibold text-white mb-2">Implementation Options</h3>
          <p className="text-gray-300 mb-4">
            We offer flexible implementation packages based on your priorities.
          </p>
          <div className="flex flex-wrap gap-3">
            <button
              type="button"
              onClick={() => window.open('https://wa.me/8801737378258?text=Regarding%20Sales%20Module%20Features', '_blank')}
              className="flex items-center px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md transition"
            >
              <WhatsAppOutlined className="mr-2" />
              Discuss Priorities
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SalesFuturePlan;
